<template>
  <div
    class="shop-the-look-collage"
    :class="`shop-the-look-collage--${template}`"
  >
    <button
      class="shop-the-look-collage__shopping"
      tabindex="-1"
      type="button"
      aria-hidden="true"
      @click.prevent="toggleIsShopping"
    />

    <button
      class="shop-the-look-collage__shop-btn"
      :class="{'is-shopping': isShopping}"
      type="button"
      :aria-label="$string('shop_the_look.toggle_shopping_accessibility_text')"
      @click.prevent="toggleIsShopping"
    >
      <icon-cart />

      <span
        class="
          shop-the-look-collage__shop-btn-label
          text-body-2xs-regular
        "
        v-text="$string('lookbook.shop_the_look')"
      />
    </button>

    <template v-for="(product, index) of products">
      <div
        v-if="shouldShowProduct(product, index)"
        :key="product.id"
        class="shop-the-look-collage__image"
        :class="`shop-the-look-collage__image--${index}`"
      >
        <div>
          <responsive-image
            :image="getProductImage(product)"
            ratio="3:4"
            sizes="(min-width: 1024px) 25vw, 50vw"
            :lazyload="false"
            :loaded-animation="false"
          />
        </div>
      </div>

      <button
        v-if="isShopping && shouldShowProduct(product, index)"
        :key="product.id"
        :aria-label="$string('shop_the_look.view_product_accessibility_text', {
          replace: { 'product': product.title },
        })"
        class="shop-the-look-collage__product-link"
        :class="`shop-the-look-collage__product-link--${index}`"
        type="button"
        @click.prevent="$emit('product-click', product)"
      >
        <span
          class="shop-the-look-collage__product-link__title"
          v-text="product.title"
        />
      </button>
    </template>
  </div>
</template>

<script>

/**
 * Vue: Shop the look collage (shop-the-look-collage)
 * -----------------------------------------------------------------------------
 * Shop the Look Collage section.
 *
 * @param {Array} products - The products in order for the collage
 * @param {String} template - The collage template
 *
 */
import IconCart from '~icons/general/cart.svg'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ShopTheLookCollage',

  components: {
    IconCart,
    ResponsiveImage,
  },

  props: {
    products: {
      type: Array,
      default: () => [],
      required: true,
    },
    template: {
      type: String,
      default: '',
      required: true,
    },
  },

  emits: {
    'product-click': () => true,
  },

  data() {
    return {
      isShopping: false,
    }
  },

  methods: {

    /**
     * Gets a product's image.
     * @param {Object|null} product - The product.
     * @returns {Object|null}
     */
    getProductImage(product) {
      if (!product) {
        return false
      }

      return product.selectedOrFirstAvailableVariant?.image ||
        product.variants[0]?.image ||
        product.media[0]?.image
    },

    /**
     * Whether the product should be shown in the template.
     * @param {Object|null} product - The product.
     * @param index - The product's index in the template.
     */
    shouldShowProduct(product, index) {
      return product && !(this.template === 'c' && index === 4)
    },

    /**
     * Toggles the collage shopping experience.
     */
    toggleIsShopping() {
      this.isShopping = !this.isShopping
    },
  },
}
</script>

<style lang="scss">
@import './shop-the-look-collage';
</style>
